import Button from "Components/Global/Buttons";

import styled from "styled-components";

// Botão "PDF comercial" (book de captação). Override do hover da variant
// tertiary outline SÓ aqui: o hover global pinta o fundo de laranja mantendo o
// texto laranja — ilegível. Aqui o fundo do hover usa o amarelo da borda
// (primary.springGreen) com texto escuro. A variant global não muda de
// propósito: ela serve todo botão tertiary outline do app.
const BookButton = styled(Button)`
  &:hover:not([disabled]) {
    background-color: ${({ theme }) => theme.colors.primary.springGreen};
    color: ${({ theme }) => theme.colors.neutral.black};
  }
`;

export default BookButton;
